import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ChatButton from '../components/ChatButton';
import InProgress from '../components/InProgress';
import { Helmet } from 'react-helmet-async'; // Correct import
import SupportSkeleton from "../components/SupportSkeleton";

function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-GB', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    return `${day} ${month}, ${year}`;
  };

  const calculateReadingTime = (content) => {
    const wordsPerMinute = 200;
    const wordCount = content.split(" ").length;
    return Math.ceil(wordCount / wordsPerMinute);
  };

  useEffect(() => {
	   const timestamp = new Date().getTime();
    fetch(`https://www.pixelliongroup.com/seotic/getSupport.php?_=${timestamp}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (Array.isArray(data)) {
          setBlogs(data);
        } else {
          throw new Error("Expected an array but received something else");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching blogs:", error);
        setError(error);
        setLoading(false);
      });
  }, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredBlogs = blogs.filter((post) =>
    post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    post.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    post.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Group blogs by category
  const groupedBlogs = filteredBlogs.reduce((acc, post) => {
    if (!acc[post.category]) {
      acc[post.category] = [];
    }
    acc[post.category].push(post);
    return acc;
  }, {});

  if (loading) {
    return (
      <>
        <Navbar />
       <SupportSkeleton />
       <Footer />
      </>
    );
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
     {/* Helmet component to wrap all meta tags and title */}
      <Helmet>
        <title>Seotic Support - Powerful SEO Tools for Small Businesses</title>
        <meta
          name="description"
          content="Seotic provides easy to use SEO tools for small businesses to enhance online visibility, drive traffic, and grow your brand. Get started with Seotic today!"
        />
        <meta name="keywords" content="SEO, SEO tools, small business, digital marketing, online visibility, Seotic" />
        <link rel="icon" href="https://www.seotic.co/favicon.ico" />

        {/* Open Graph Meta Tags */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.seotic.co" />
        <meta property="og:title" content="Seotic - SEO Tools for Small Businesses" />
        <meta
          property="og:description"
          content="Optimize your website's SEO with Seotic's powerful, user friendly tools designed for small businesses. Start improving your search rankings today!"
        />
        <meta property="og:image" content="https://www.seotic.co/og-image.jpg" />

        {/* Twitter Card Meta Tags */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://www.seotic.co" />
        <meta property="twitter:title" content="Seotic - SEO Tools for Small Businesses" />
        <meta
          property="twitter:description"
          content="Optimize your website's SEO with Seotic's powerful, user friendly tools designed for small businesses. Start improving your search rankings today!"
        />
        <meta property="twitter:image" content="https://www.seotic.co/og-image.jpg" />
      </Helmet>

      <Navbar />
      <div className="bg-slate-100 h-full">
        <div className="container mx-auto py-12 px-4 md:px-0">
        <InProgress />
         <h2 className="text-center text-base/7 uppercase text-slate-400 mt-10">Support</h2>
      <p className="mx-auto mt-2 max-w-lg text-center text-4xl font-semibold tracking-tight text-balance text-gray-950 sm:text-5xl">
       Find answers, guides and solutions
      </p>

          {/* Search Bar */}
          <div className="mb-12 flex justify-center mt-10">
            <input
              type="text"
              placeholder="Search by title, category, or description..."
              value={searchTerm}
              onChange={handleSearch}
              className="px-4 py-2 border border-slate-200 rounded-lg w-full max-w-md focus:outline-none"
            />
          </div>
 <div className="grid md:gap-5 gap-2 md:grid-cols-2 lg:grid-cols-3">
        {/* Grouped Blog Posts by Category */}
{Object.keys(groupedBlogs).map((category) => (
  <div key={category} className="bg-white rounded-lg overflow-hidden border border-slate-200">
    <h3 className="text-2xl font-medium text-slate-800 mb-6 px-10 pt-10">
      {category} <p className="text-sm text-slate-400">{groupedBlogs[category].length} Articles</p>
    </h3>
    <div className="">
      {groupedBlogs[category].map((post) => (
        <div key={post.parama} className="px-10 py-5 border-b border-slate-200 last:border-0">
          <Link to={`/help/${post.parama}`} className="">
            <h3 className="text-lg font-normal"><i class='bx bx-file bx-fw'></i> {post.title}</h3>
          </Link>
        </div>
      ))}
    </div>
  </div>
))}

		      </div>
          {/* No Results Message */}
          {filteredBlogs.length === 0 && (
            <div className="text-center text-slate-500 mt-8 mb-8">
              No article found for "{searchTerm}"
            </div>
          )}
                 </div>
        
      </div>
      
      <Footer />
    </>
  );
}

export default Blog;
